import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig"; // Ajusta si estás en otra carpeta

export const searchPatientsByName = async (name) => {
  try {
    const url = `${API_BASE_URL}/api/PatientInfo/allName`;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      params: { Name: name }, // Usamos `params` de Axios, más limpio que concatenar manualmente
    });
    return response.data;
  } catch (error) {
    console.error("Error searching patients:", error);
    throw error;
  }
};
